import { Injectable } from '@angular/core'
import { Query } from '@datorama/akita'
import { Observable } from 'rxjs'
import type { User } from '@app/core'
import { SessionStore, SessionState } from './session.store'

@Injectable({ providedIn: 'root' })
export class SessionQuery extends Query<SessionState> {
  selectUser$ = this.select('user')

  constructor(protected store: SessionStore) {
    super(store)
  }

  isLoggedIn$ = this.select(state => !!state.user)

  selectPermission(permission: string): Observable<boolean> {
    return this.select(state => state.user?.Permissions.some(p => p.PermissionName === permission))
  }

  isLoggedIn(): boolean {
    return !!this.getValue().user
  }

  get getUser(): User | null {
    return this.getValue().user
  }
}
